var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useCallback, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { ClearApplyButtons } from "../../../../../Common";
import { LocationAutocomplete } from "../../Molecules";
var LocationFilter = function (_a) {
    var value = _a.value, onClear = _a.onClear, onSubmit = _a.onSubmit, stateOptions = _a.stateOptions, cityOptions = _a.cityOptions, actionRef = _a.actionRef, _b = _a.hideSublocationIfEmpty, hideSublocationIfEmpty = _b === void 0 ? false : _b;
    // get city values from a given state selection
    var getCityValues = useCallback(function (state) {
        var _a, _b;
        return state
            ? ((_b = (_a = stateOptions === null || stateOptions === void 0 ? void 0 : stateOptions.mapping) === null || _a === void 0 ? void 0 : _a[state.id]) === null || _b === void 0 ? void 0 : _b.map(function (city) { return ({ name: city, id: city }); })) || []
            : [];
    }, []);
    var defaultValues = useMemo(function () {
        // ensures valid input instead of blindly setting what db returns
        var defaultState = stateOptions.options.filter(function (o) { var _a, _b; return ((_b = (_a = value === null || value === void 0 ? void 0 : value.field1) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) === o.id; });
        var initCityOptions = (defaultState === null || defaultState === void 0 ? void 0 : defaultState.length)
            ? getCityValues(defaultState[0])
            : [];
        var defaultCity = initCityOptions.filter(function (o) { var _a, _b; return ((_b = (_a = value === null || value === void 0 ? void 0 : value.field2) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) === o.id; });
        return {
            state: (defaultState === null || defaultState === void 0 ? void 0 : defaultState[0]) || null,
            city: (defaultCity === null || defaultCity === void 0 ? void 0 : defaultCity[0]) || null,
        };
    }, []);
    var methods = useForm({
        criteriaMode: "all",
        mode: "all",
        defaultValues: defaultValues,
    });
    var state = methods.watch().state;
    var cityValues = useMemo(function () { return getCityValues(state); }, [state]);
    /**
     * Clear filter if no items are selected, otherwise submit values
     */
    var handleSubmit = function () {
        var _a;
        var data = methods.getValues();
        if (!data.state) {
            onClear();
        }
        else {
            onSubmit({
                state: [data.state.id],
                city: ((_a = data === null || data === void 0 ? void 0 : data.city) === null || _a === void 0 ? void 0 : _a.id) ? [data.city.id] : null,
            });
        }
    };
    // when state changes we need to reset city selection
    var onStateChange = function (_data) {
        methods.setValue("city", null);
    };
    // hide sublocation field only when there are no values and hideSublocationIfEmpty is true
    var displaySublocation = !(cityValues.length === 0 && hideSublocationIfEmpty);
    return (_jsx(Stack, __assign({ alignItems: "center" }, { children: _jsx(Stack, __assign({ width: "100%" }, { children: _jsx(FormProvider, __assign({}, methods, { children: _jsxs("form", { children: [_jsxs(Stack, __assign({ gap: 4 }, { children: [_jsx(LocationAutocomplete, __assign({ name: "state", callback: onStateChange, placeholder: (stateOptions === null || stateOptions === void 0 ? void 0 : stateOptions.placeholder) || "All states", actionRef: actionRef }, stateOptions)), displaySublocation && (_jsx(LocationAutocomplete, __assign({ placeholder: (cityOptions === null || cityOptions === void 0 ? void 0 : cityOptions.placeholder) || "All cities", name: "city", actionRef: actionRef }, cityOptions, { options: cityValues })))] })), _jsx(ClearApplyButtons, { onClear: onClear, handleSubmit: handleSubmit, isDirty: methods.formState.isDirty })] }) })) })) })));
};
export default LocationFilter;
